export class SmartphotoNotification {
    scheduled;
    status;
    type;
    constructor(notification) {
        this.scheduled = notification.scheduled * 1000;
        this.status = notification.status;
        this.type = notification.notificationType;
    }
}
